import { Button, Result, Typography } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";

const { Paragraph, Text } = Typography;
function NotFound() {
  const navigate = useNavigate();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        textAlign: "center",
        padding: "1vh 15vw",
      }}
    >
      <Paragraph
        style={{
          fontSize: "7rem",
          fontWeight: 700,
          textShadow: "2px 4px 6px #000",
          margin: 0,
          color: "#146f8d",
        }}
      >
        404
      </Paragraph>
      <Paragraph
        style={{ color: "#424242" }}
        ellipsis={{ rows: 2, expandable: true, symbol: "read more" }}
      >
        Apologies for the inconvenience. It seems that the page you are
        attempting to access has either been removed, or there might be an issue
        with the provided URL. Please verify or correct the URL and try your
        request again. Thank you for your understanding.
      </Paragraph>
      <Paragraph>
        <Button type="primary" onClick={() => navigate(-1)}>
          Back
        </Button>
      </Paragraph>
    </div>
  );
}

export default NotFound;
